import qs from 'qs'

import { UploadFileResponseData } from '@features/attachments/query-api'

import { ApiContentType } from '../../enums/apiContentType'
import { deleteRequest, getRequest, patchRequest, postV2Request } from '../../utils'
import { ScoutProvider } from './enums/scoutProvider'
import { ScoutReceiptDeletionReason } from './enums/scoutReceiptDeletionReason'
import { ScoutConnection } from './types/scoutConnection'

export interface DeleteReceiptsBulkPayload {
  receiptsIds: string[]
  reason?: ScoutReceiptDeletionReason
}

export const deleteReceiptsBulk = ({
  receiptsIds,
  reason,
}: DeleteReceiptsBulkPayload): Promise<UploadFileResponseData> => {
  const query = qs.stringify({ ids: receiptsIds, deletionReason: reason })
  return deleteRequest(`/v2/attachments?${query}`)
}

export const fetchScoutConnections = (organizationId: string): Promise<ScoutConnection[]> => {
  return getRequest(`/email-scanning/organization/${organizationId}/connection`)
}

export interface CreateScoutConnectionImapPayload {
  accountIds: string[]
  email: string
  host: string
  port: number
  organizationId: string
  organizationUrl: string
  password: string
}

export interface CreateScoutConnectionImapResponse {
  connectionId: string
  success: boolean
}

export const createScoutConnectionImap = (
  props: CreateScoutConnectionImapPayload,
): Promise<CreateScoutConnectionImapResponse> => {
  return postV2Request({
    endpoint: `/email-scanning/organization/${props.organizationId}/connection`,
    payload: {
      accountIds: props.accountIds,
      organizationUrl: props.organizationUrl,
      password: props.password,
      user: props.email,
      host: props.host,
      port: props.port,
    },
    options: {
      contentType: ApiContentType.ApplicationJSON,
    },
  })
}

export interface CreateScoutConsentUrlPayload {
  accountIds: string[]
  organizationId: string
  organizationUrl: string
}
export interface CreateScoutConsentUrlResponse {
  [ScoutProvider.Google]: string
  [ScoutProvider.Microsoft]: string
}

export const createScoutConsentUrl = (props: CreateScoutConsentUrlPayload): Promise<CreateScoutConsentUrlResponse> => {
  return postV2Request({
    endpoint: `/email-scanning/organization/${props.organizationId}/connection/consent-url`,
    payload: {
      accountIds: props.accountIds,
      organizationUrl: props.organizationUrl,
    },
    options: {
      contentType: ApiContentType.ApplicationJSON,
    },
  })
}

export interface DeleteScoutConnectionPayload {
  connectionId: string
  organizationId: string
}
export interface DeleteScoutConnectionResponse {
  success: boolean
}

export const deleteScoutConnection = (props: DeleteScoutConnectionPayload): Promise<DeleteScoutConnectionResponse> => {
  return deleteRequest(`/email-scanning/organization/${props.organizationId}/connection/${props.connectionId}`)
}

export interface UpdateScoutConnectionPayload {
  connectionId: string
  organizationId: string
  lastFetchedAt?: string
  syncNow?: boolean
}
export interface UpdateScoutConnectionResponse {
  status: boolean
}

export const updateScoutConnection = ({
  connectionId,
  organizationId,
  lastFetchedAt,
  syncNow,
}: UpdateScoutConnectionPayload): Promise<UpdateScoutConnectionResponse> => {
  return patchRequest(`/email-scanning/organization/${organizationId}/connection/${connectionId}`, {
    lastFetchedAt,
    syncNow,
  })
}
